import { Popover, Transition, Dialog } from "@headlessui/react";
import {
  UserCircleIcon,
  ArrowRightOnRectangleIcon,
  TrashIcon
} from "@heroicons/react/24/outline";
import { Fragment, useContext, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Avatar from "shared/Avatar/Avatar";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "context/userContext";
import axios from "axios";
import { API_URL } from "api/config";
import { toast } from "react-toastify";

const solutions = [
  {
    name: "Profile",
    href: "/account",
    icon: UserCircleIcon,
  },
];

const solutionsFoot = [
  {
    name: "Logout",
    icon: ArrowRightOnRectangleIcon,
  },
  {
    name:"Delete Account",
    icon: TrashIcon,
  }
];

export default function AvatarDropdown() {
  const authContext = useContext(AuthContext);
  const dataAdmin = authContext.ownerData;
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [imageReloadKey, setImageReloadKey] = useState(Date.now());

    useEffect(() => {
    if (dataAdmin?.image) {
      setImageReloadKey(Date.now());
    }
  }, [dataAdmin?.image]);
  const popoverRef = useRef(null);
  const token = localStorage.getItem("token");
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const popoverElement = popoverRef.current as HTMLElement | null;
      if (popoverElement && !popoverElement.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const closePopover = () => {
    setIsOpen(false);
  };
  const handleDeleteClick = () => {
    setIsDeleteModalOpen(true);
  }

  const confirmDeleteAccount = async () => {
    setIsDeleteModalOpen(false);
    try {
      const response = await axios.post(`${API_URL}/owner/delete-account`,{}, {
        headers: {
          token: token,
        },
      });
      if (response.data.error === false) {
        toast.success(`${response.data.message}`);
        authContext.onLogout();
        closePopover();
        navigate("/login", {replace : true});    
      }
    } catch (error) {
      toast.error("Failed to delete account");
    }
  };
      const getAvatarImageUrl = (url: string | undefined) => {
    if (!url) {
      return "";
    }
    // Only apply cache busting if it's a URL and not a Base64 string
    if (url.startsWith("data:image")) {
      return url;
    }
    return `${url}?${imageReloadKey}`;
  };
  return (
    <div className="AvatarDropdown relative">
      <Popover
        onClick={closePopover}
        as="div"
        className="AvatarDropdown relative"
        ref={popoverRef}
      >
        {({ open }) => (
          <>
            <Popover.Button
              className={`inline-flex items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75`}
              onClick={() => setIsOpen(!isOpen)}
            >
              <div
                className="border flex gap-4 pl-3 pr-2 py-2"
                style={{ borderRadius: "35px", transition: "box-shadow 0.3s" }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.boxShadow =
                    "0 1.4px 2.5px rgba(0, 0, 0, 0.3)")
                }
                onMouseOut={(e) => (e.currentTarget.style.boxShadow = "none")}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 flex justify-center m-auto"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                    clipRule="evenodd"
                  ></path>
                </svg>
                <div className="flex justify-center m-auto">
                  <Avatar
                    sizeClass="w-8 h-8 sm:w-7 sm:h-7"
                    // imgUrl={dataAdmin?.image}
                    imgUrl={getAvatarImageUrl(dataAdmin?.image)}
                    ownerFirstName={dataAdmin?.firstname}
                    ownerLastName={dataAdmin?.lastname}

                  />
                </div>
              </div>
            </Popover.Button>
            <Transition
              show={isOpen}
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel className="absolute z-10 w-screen max-w-[260px] px-4 mt-2 -right-10 sm:right-0 sm:px-0">
                <div className="overflow-hidden rounded-3xl shadow-lg ring-1 ring-black ring-opacity-5">
                  <div className="relative grid gap-6 bg-white dark:bg-neutral-800 p-7">
                    <div
                      className="flex items-center p-2 -m-3 transition duration-150 ease-in-out rounded-lg focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50"
                      onClick={closePopover}
                    >
                      <div className="flex items-center justify-center flex-shrink-0 text-neutral-500 dark:text-neutral-300">
                        {/* {item.icon && (
                          <item.icon aria-hidden="true" className="w-6 h-6" />
                        )} */}
                        <Avatar
                          sizeClass="w-12 h-12"
                          // imgUrl={dataAdmin?.image}
                          imgUrl={getAvatarImageUrl(dataAdmin?.image)}
                          ownerFirstName={dataAdmin?.firstname}
                          ownerLastName={dataAdmin?.lastname}

                        />
                      </div>
                      <div className="ml-4">
                        <p className="text-sm font-medium ">
                          {`${dataAdmin?.firstname} ${dataAdmin?.lastname}`}
                        </p>
                        <p className="text-sm font-light">
                          {dataAdmin?.email && dataAdmin.email.length > 15
                            ? `${dataAdmin.email.slice(
                                0,
                                6
                              )}...${dataAdmin.email.slice(-10)}`
                            : dataAdmin?.email}
                        </p>
                      </div>
                    </div>
                  </div>
                  <hr className="h-[1px] border-t border-neutral-300 dark:border-neutral-700" />
                   <Link
                    to={solutions[0]?.href || "#"} // Default to the first item's link or "#" if empty
                    className="relative grid gap-6 bg-white dark:bg-neutral-800 p-7 hover:bg-gray-200 dark:hover:bg-gray-700 "
                    onClick={closePopover}
                  >
                    <div>
                      {solutions.map((item, index) => (
                        <div
                          key={index}
                          className="flex items-center p-2 -m-3 transition duration-150 ease-in-out rounded-lg focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50"
                        >
                          <div className="flex items-center justify-center flex-shrink-0 text-neutral-500 dark:text-neutral-300">
                            {item.icon && (
                              <item.icon
                                aria-hidden="true"
                                className="w-6 h-6"
                              />
                            )}
                          </div>
                          <div className="ml-4">
                            <p className="text-sm font-medium">{item.name}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </Link>
                  <hr className="h-[1px] border-t border-neutral-300 dark:border-neutral-700" />
                         {solutionsFoot.map((item, index) => (
                    <div key={index}>
                     <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        if (item.name === "Delete Account") {                          
                          handleDeleteClick();
                        } else {
                          authContext.onLogout();
                          toast.success("Logged out successfully");
                          closePopover();
                          navigate("/login", {replace : true});     
                        }
                      }}
                      className="relative grid gap-8 bg-white dark:bg-neutral-800 p-7 hover:bg-gray-200 dark:hover:bg-gray-700 transition duration-150 ease-in-out focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50 cursor-pointer"
                    >
                      <div className="flex items-center">
                        <div className="flex items-center justify-center flex-shrink-0 text-neutral-500 dark:text-neutral-300">
                          {item.icon && (
                            <item.icon aria-hidden="true" className="w-6 h-6" />
                          )}
                        </div>
                        <div className="ml-4">
                          <p className="text-sm font-medium text-neutral-500 dark:text-neutral-500">
                            {item.name}
                          </p>
                        </div>
                      </div>
                    </a>
                    <hr className="h-[1px] border-t border-neutral-300 dark:border-neutral-700" />

                    </div>
                   
                    
                  ))}
                </div>
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
            {/* DELETE ACCOUNT MODAL */}
     <Transition show={isDeleteModalOpen} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50"
          onClose={() => setIsDeleteModalOpen(false)}
        >
          <Dialog.Panel className="bg-white dark:bg-gray-900 p-6 rounded-lg max-w-lg w-full shadow-xl">
            <Dialog.Title className="text-lg font-semibold text-center">
              Confirm Account Deletion
            </Dialog.Title>
            <p className="text-sm text-gray-600 dark:text-gray-400 text-center mt-2">
              Are you sure you want to delete your account? This action cannot
              be undone.
            </p>
            <div className="mt-4 flex justify-center gap-4">
              <button
                onClick={() => setIsDeleteModalOpen(false)}
                className="px-4 py-2 bg-gray-300 dark:bg-gray-700 rounded-md"
              >
                No, Cancel
              </button>
              <button
                onClick={confirmDeleteAccount}
                className="px-4 py-2 bg-red-600 text-white rounded-md"
              >
                Yes, Delete Account
              </button>
            </div>
          </Dialog.Panel>
        </Dialog>
      </Transition>
    </div>
  );
}
